import _ from 'lodash'
import { UUID } from '../../plugins/common'
import { relationTypes } from './schema'
import sdk from 'redcatSdk'

// 1. 整合所有属性到此文件中。
// 2. 整理属性项。
const properties = {
  'address': {
    addressRequired: {
      province: false,
      city: false,
      area: false,
      address: false
    }
  },
  'alignment': {
    justifyContent: 'center',
    alignItems: 'flex-start',
    fontWeight: 'normal',
    color: '#000'
  },
  'archived': {
    archived: {
    }
  },
  'archived-table': {
    archivedTable: {
    }
  },
  'currency-type': {
    currencyType: '人民币'
  },
  'setting-option': {
    dataSource: {
      enable: false,
      dataSource: '',
      reportId: '',
      columnId: '',
      showColumnId: '',
      // 数据绑定
      bindData: {
        enable: false,
        dataBinding: [{showColumnId: '', componentId: ''}]
      }
    },
    template: {
      enable: true,
      method: 'static',
      groupId: '1',
      stringOptions: '选项1\n选项2\n选项3'
    }
  },
  'data-source-privide': {
    dataSourceData: {
      dataSource: '',
      showColumnId: '',
      dataBinding: [],
      filter: {},
      filterHide: {}
    }
  },
  'date-type': {
  },
  'setting-value': {
    default: {
      settingEnable: true,
      defaultValue: '',
      secondDefaultValue: '',
      enable: false
    },
    calculate: {
      enable: false,
      calculationPanelData: {
        expression: '',
        secondExpression: ''
      },
      realTime: false
    },
    related: {
      enable: false,
      tableId: '',
      relComponent: '',
      srcLocation: '',
      relField: '',
      srcField: '',
      secondRelComponent: '',
      secondSrcLocation: '',
      secondRelField: '',
      secondSrcField: ''
    }
  },
  'discern': {
    discriminate: {
      recognizeAddr: '',
      recognizeSex: '',
      recognizeBirthday: '',
      recognizeAge: ''
    }
  },
  'height': {
    height: ''
  },
  'hidden': {
    hidden: false,
    seat: false
  },
  'limit': {
    limit: {
      enable: false,
      // 触发方式是否为blur默认为true
      triggerBlur: true,
      rules: []
    }
  },
  'max-row-module': {
    numberOfColumns: 4,
    numberOfLines: 4,
    maxNum: 5,
    enableEdit: false,
    selectForm: '[默认表单]',
    selectProperties: ''
  },
  'name': {
    name: ''
  },
  'placeholder': {
    placeholder: '',
    endTimeplaceholder: ''
  },
  'postfix': {
    numType: 'num',
    customSuffix: '',
    decimal: '2'
  },
  'code': {
    code: {
      startNumber: '1',
      length: '3',
      expression: '',
      isPrefix: false,
      isRestart: false
    }
  },
  'readonly': {
    readonly: false
  },
  'relevance': {
    loginUser: {
      jobNum: '',
      department: '',
      post: ''
    }
  },
  'repeatability': {
    repeatability: false
  },
  'required': {
    required: false
  },
  'row-col': {
    numberOfColumns: 4,
    numberOfLines: 2
  },
  'search-choose': {
    multiple: false,
    search: false
  },
  'sizex': {
    sizex: ''
  },
  'sizey': {
    numberOfLines: 2
  },
  'thousand': {
    bit: false
  },
  'time': {
    calTimeType: 'positiveTiming',
    checkTime: 'first',
    time: {
      HH: 0,
      mm: 0,
      ss: 0
    }
  },
  'tree': {
    tree: {
      // 手风琴
      accordion: false,
      // 是否筛选
      filter: false,
      // 筛选条件
      filterText: '',
      // 关联控件
      isRelComponents: [{ archivedId: '' }],
      // 树节点控件
      treeName: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 结构
      structure: [
        {
          id: UUID.create(),
          label: '一级 1',
          children: [
            {
              id: UUID.create(),
              label: '二级 1'
            }, {
              id: UUID.create(),
              label: '二级 2'
            }, {
              id: UUID.create(),
              label: '二级 3'
            }
          ]
        }
      ],
      // 数据
      data: []
    }
  },
  'trigger-mode': {
    openModel: 'dialog',
    link: { dataSource: 'outside', external: 'https://', reportCategory: '', reportId: '' }
  },
  'unfold': {
    organ: {
      childId: '',
      show: true
    }
  },
  'upload': {
    multiple: true,
    drag: false,
    listType: '',
    fileSize: '',
    allowFileType: []
  },
  'label-content': {
    value: ''
  },
  'ocr': {
    ocr: {
      type: 'text',
      rules: {}
    }
  },
  'disable-copy': {
    disableCopy: false
  },
  'disable-paste': {
    disablePaste: false
  },
  'describe-message': {
    message: {
      oneMessage: '',
      twoMessage: '',
      threeMessage: '',
      fourMessage: '',
      fiveMessage: ''
    }
  },
  'isOpen': {
    isOpen: true
  },
  'add-options': {
    addOptions: false
  },
  'big-file-upload': {
    requestUrl: ''
  },
  'layout': {
    // 双列布局类型 d1: 1：1，d2: 1：3， d3: 3：1；
    // 三列布局类型 t1: 1：1：1, t2: 1：2：1, t3: 1：1：2, t4: 2：1：1
    layoutRatioType: ''
  },
  'report': {
    report: {
      sourceTableId: '',
      filters: null,
      defaultRows: 4
    }
  },
  // 图片展示控件
  'image': {
    slideModel: true,
    imageList: []
  },
  // 分组控件折叠
  'fold': {
    defaultFold: false
  },
  // 表格锁定行数
  'lock-row': {
    lockRow: false
  },
  // 时间区间可选日期
  'select-data': {
    selectData: {
      startData: '',
      endData: ''
    }
  },
  // 级联下拉-设置选项
  'setting-cascader': {
    settingCascader: {
      // 归档文本
      dataSourceReportId: '',
      bindData: {
        enable: false,
        dataBinding: [{showColumnId: '', componentId: ''}]
      },
      cascaderOptions: [
        {optionId: '', optionShowId: ''},
        {optionId: '', optionShowId: ''}
      ]
    }
  },
  // 单选、复选排序方式
  'sort-orientation': {
    sortOrientation: 'horizontal'
  },
  // 可勾选数据
  'check-line': {
    checkLine: false
  },
  // 数字步幅
  'stride': {
    stride: {
      enable: false,
      number: null
    }
  },
  // 超链接区别新老设计的flag
  'new-design': {
    newDesign: false
  }
}
const componentProperties = {
  'rc-form': {
    // 创建组件时使用的构造函数
    ctor: 'TableComponent',
    // 组建可使用的属性设置
    props: [],
    // 属性默认值
    defaults: {
      name: '表单',
      componentType: 'rc-form',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      formValidates: [],
      interactions: [],
      properties: {formScreen: 'full', continueCreate: false, groupNav: false, enableLog: false, enableDiscuss: false},
      pinyinName: '',
      pinyinFirstChar: ''

    }
  },
  'rc-process': {
    ctor: 'ProcessComponent',
    props: [],
    defaults: {
      name: '流程',
      componentType: 'rc-process',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {formScreen: 'full'},
      pinyinName: '',
      pinyinFirstChar: ''

    }
  },
  'rc-input': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'placeholder', 'limit', 'setting-value', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '文本框',
      componentType: 'rc-input',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-children-input': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'limit'],
    defaults: {
      name: '子控件',
      componentType: 'rc-children-input',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {
        noDelete: true,
        noCollect: true
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-combobox': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'setting-option', 'setting-value', 'search-choose', 'disable-copy', 'disable-paste', 'add-options'],
    defaults: {
      name: '下拉框',
      componentType: 'rc-combobox',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        archived: {showColumnId: ''},
        placeholder: '请选择'
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-cascader': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'input-width', 'setting-cascader'],
    defaults: {
      name: '级联下拉',
      componentType: 'rc-cascader',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        archived: {showColumnId: ''},
        placeholder: '请选择'
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-date': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'date-type', 'setting-value', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '日期框',
      componentType: 'rc-date',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'date'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-numeric': {
    ctor: 'ColumnComponent',
    props: ['name', 'readonly', 'placeholder', 'postfix', 'setting-value', 'input-width', 'required', 'limit', 'thousand', 'archived', 'stride', 'disable-copy', 'disable-paste', 'js-actions'],
    defaults: {
      name: '数字框',
      componentType: 'rc-numeric',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal0'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-textarea': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'height', 'limit', 'setting-value', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '大文本框',
      componentType: 'rc-textarea',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'text'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 2
    }
  },
  'rc-table': {
    ctor: 'TableComponent',
    props: ['name', 'hidden', 'archived-table', 'max-row-module', 'readonly', 'lock-row', 'disable-copy', 'disable-paste', 'check-line'],
    defaults: {
      name: '表格',
      componentType: 'rc-table',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar',
        relationType: relationTypes.ONE2MANY
      },
      properties: {
        widths: []
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 3
    }
  },
  'rc-rich-box': {
    ctor: 'ColumnComponent',
    props: ['name', 'hidden', 'heightAdaptation', 'height', 'archived', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '富文本框',
      componentType: 'rc-rich-box',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'html'
      },
      properties: {
        height: 200
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 2
    }
  },
  'rc-coding': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'code', 'disable-copy'],
    defaults: {
      name: '编码框',
      componentType: 'rc-coding',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-flowing-water': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'code', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '流水框',
      componentType: 'rc-flowing-water',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-label': {
    ctor: 'ColumnComponent',
    props: ['name', 'label-content', 'hidden', 'height', 'disable-copy'],
    defaults: {
      name: '文本标签',
      componentType: 'rc-label',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        labelContent: ''
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-button': {
    ctor: 'ColumnComponent',
    props: ['name', 'alignment'],
    defaults: {
      name: '按钮',
      componentType: 'rc-button',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-currency': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'setting-value', 'postfix', 'currency-type', 'thousand', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '货币框',
      componentType: 'rc-currency',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal0'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-radio': {
    ctor: 'ColumnComponent',
    props: ['name', 'height', 'required', 'archived', 'hidden', 'readonly', 'sort-orientation', 'setting-option', 'setting-value', 'disable-copy'],
    defaults: {
      name: '单选框',
      componentType: 'rc-radio',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-checkbox': {
    ctor: 'ColumnComponent',
    props: ['name', 'height', 'required', 'archived', 'hidden', 'readonly', 'sort-orientation', 'setting-option', 'setting-value', 'disable-copy'],
    defaults: {
      name: '复选框',
      componentType: 'rc-checkbox',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-upload': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'upload', 'required', 'hidden', 'disable-copy'],
    defaults: {
      name: '文件上传',
      componentType: 'rc-upload',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-big-file-upload': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'bigFileUpload', 'required', 'hidden'],
    defaults: {
      name: '大文件上传',
      componentType: 'rc-big-file-upload',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-file': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'upload', 'required', 'hidden', 'disable-copy'],
    defaults: {
      name: '文件选择',
      componentType: 'rc-file',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-ocr': {
    ctor: 'ColumnComponent',
    props: ['name', 'ocr', 'archived'],
    defaults: {
      name: '文字识别',
      componentType: 'rc-ocr',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-data-source': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'data-source-privide', 'disable-copy'],
    defaults: {
      name: '数据源',
      componentType: 'rc-data-source',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-cal-time': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'readonly', 'time', 'disable-copy'],
    defaults: {
      name: '计时器',
      componentType: 'rc-cal-time',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-content-table': {
    ctor: 'TableComponent',
    props: ['name', 'row-col'],
    defaults: {
      name: '内容表格',
      componentType: 'rc-content-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-hyperlink': {
    ctor: 'ColumnComponent',
    props: ['name', 'readonly', 'component-explain', 'required', 'archived', 'disable-copy', 'js-actions', 'new-design'],
    defaults: {
      name: '超链接',
      componentType: 'rc-hyperlink',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-report': {
    ctor: 'ColumnComponent',
    props: ['name', 'report', 'hidden', 'js-actions'],
    defaults: {
      name: '报表',
      componentType: 'rc-report',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-image': {
    ctor: 'ColumnComponent',
    props: ['name', 'image'],
    defaults: {
      name: '图片展示',
      componentType: 'rc-image',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-uuid': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'disable-copy'],
    defaults: {
      name: '唯一标识',
      componentType: 'rc-uuid',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'identity'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-id-card': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'setting-value', 'discern', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '身份证号',
      componentType: 'rc-id-card',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {
        limit: { enable: true, rules: [{ 'limitType': '身份证' }] }
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-login-user': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'readonly', 'relevance', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '登录人',
      componentType: 'rc-login-user',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-phone': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '手机号',
      componentType: 'rc-phone',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-address': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'address', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '地址控件',
      componentType: 'rc-address',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 1
    }
  },
  'rc-password': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'placeholder', 'limit', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '密码框',
      componentType: 'rc-password',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-group': {
    ctor: 'TableComponent',
    props: ['name', 'fold', 'hidden'],
    defaults: {
      name: '分组',
      componentType: 'rc-group',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        hidden: false,
        seat: false
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-multiple-tabs': {
    ctor: 'TableComponent',
    props: ['name', 'readonly', 'js-actions', 'multiple-tabs'],
    defaults: {
      name: '多标签',
      componentType: 'rc-multiple-tabs',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        hidden: false,
        seat: false,
        activeIndex: 0,
        tabCompnents: [[], [], []],
        showLayers: [],
        tabList: []
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-layout': {
    ctor: 'TableComponent',
    props: ['layout'],
    defaults: {
      name: '布局',
      componentType: 'rc-layout',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-draggable': {
    ctor: 'TableComponent',
    props: [],
    defaults: {
      name: 'draggable',
      componentType: 'rc-draggable',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  //  成员控件
  'rc-member': {
    // 创建组件时使用的构造函数
    ctor: 'ColumnComponent',
    // 组建可使用的属性设置
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'js-actions'],
    // 属性默认值
    defaults: {
      name: '成员',
      componentType: 'rc-member',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: '',
      position: {
        'w': 1,
        'h': 1
      }
    }
  },
  'rc-rate': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'readonly', 'hidden', 'archived', 'describe-message'],
    defaults: {
      name: '评分',
      componentType: 'rc-rate',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-switch': {
    ctor: 'ColumnComponent',
    props: ['name', 'readonly', 'hidden', 'archived', 'isOpen'],
    defaults: {
      name: '开关',
      componentType: 'rc-switch',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-time-interval': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'date-type', 'select-data', 'setting-value', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '时间区间',
      componentType: 'rc-time-interval',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'date'
      },
      properties: {
        archived: {endColumnId: ''}
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  /** 以下为定制控件(huaao) */
  'cust-input-and-btn': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly'],
    defaults: {
      name: '文本框按钮组合',
      componentType: 'cust-input-and-btn',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        button: '按钮'
      }
    }
  },
  'cust-plate-number': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: '车牌号',
      componentType: 'cust-plate-number',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true
      }
    }
  },
  'cust-note-builder': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-note-builder',
      componentType: 'cust-note-builder',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true
      }
    }
  },
  'cust-button-check-carType': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: '同类车型查看',
      componentType: 'cust-button-check-carType',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  'cust-button-export': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: '定制导出按钮',
      componentType: 'cust-button-export',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  'cust-button-add-partner': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: '添加合作商',
      componentType: 'cust-button-add-partner',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  'cust-message-builder': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-message-builder',
      componentType: 'cust-message-builder',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true
      }
    }
  },
  'cust-btn-print': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-btn-print',
      componentType: 'cust-btn-print',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  'cust-choose-car-model': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-choose-car-model',
      componentType: 'cust-choose-car-model',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  'cust-statistics-report': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-statistics-report',
      componentType: 'cust-statistics-report',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        button: '添加',
        explan: '配合程度说明：A不介绍，B被动介绍，C主动介绍，D独立出单',
        rows: [
          {id: '16B4038E-6660-0095-890E-B2FF0C4CBBA2', name: '姓名'},
          {id: '16B4038E-A050-0097-6750-1FA6A4A79402', name: '售前/后'},
          {id: '16B4038E-CF20-0099-5C9E-391E91082BB9', name: '出单数'},
          {id: '16B4038F-22F0-009B-35D9-D3CBD696E4C1', name: '配合程度'},
          {id: '16B0291C-D020-0064-7EB9-17BA1D829999', name: '操作'}
        ],
        canAdd: true
      }
    }
  },
  // 预算明细在财务审核的表
  'cust-budget-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-budget-table',
      componentType: 'cust-budget-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '预算明细复核表'
      },
      pinyinName: ''
    }
  },
  // 比价明细
  'cust-priceComparison-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-priceComparison-table',
      componentType: 'cust-priceComparison-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '比价明细'
      },
      pinyinName: ''
    }
  },
  // 固定资产汇总表
  'cust-fixed-property': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-fixed-property',
      componentType: 'cust-fixed-property',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '固定资产汇总表'
      }
    }
  },
  // 车型批量添加
  'cust-much-add': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-much-add',
      componentType: 'cust-much-add',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '车型批量添加'
      }
    }
  },
  // 车型增加流程保费表
  'cust-add-premium-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-add-premium-table',
      componentType: 'cust-add-premium-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '车型保费'
      }
    }
  },
  // 费用报销 查询明细
  'cust-search-details': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-search-details',
      componentType: 'cust-search-details',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        title: '查询'
      }
    }
  },
  // 添加考试
  'cust-participant': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-participant',
      componentType: 'cust-participant',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        selectIds: '',
        selectNames: ''
      }
    }
  },
  // 定制文件上传
  'cust-rc-file': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-rc-file',
      componentType: 'cust-rc-file',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        /* 合作商信息维护流程：
        * 主协议： 16C88D12-DFA0-03C7-8793-DF7821DC1472
        * 补充协议：16C88D53-C9A0-03D7-8595-0DF7E953B20D
        * */
        /* 开店申请：
        * 主协议： 16C88C2D-C660-020E-87EA-6F5DFF31FCFE
        * 补充协议：16C88C63-76C0-021E-CD20-AAB21A5AA187
        * */
        columnId: '16C88D12-DFA0-03C7-8793-DF7821DC1472'
      }
    }
  },
  // 晟融定制 begin
  // 还款计划
  'cust-repayment-plan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-plan',
      componentType: 'cust-repayment-plan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款计划表'
      }
    }
  },
  // 还款记录及计划
  'cust-repayment-history': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-history',
      componentType: 'cust-repayment-history',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款记录及计划'
      }
    }
  },
  // 还款计划【企业还款】
  'cust-repayment-payplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-payplan',
      componentType: 'cust-repayment-payplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款计划【企业还款】'
      }
    }
  },
  // 新还款计划表【企业还款】
  'cust-repayment-newplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-newplan',
      componentType: 'cust-repayment-newplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '新还款计划表【企业还款】 '
      }
    }
  },
  // 本次还款入账明细【企业还款】
  'cust-repayment-detail': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-detail',
      componentType: 'cust-repayment-detail',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '本次还款入账明细【企业还款】'
      }
    }
  },
  // 还款计划
  'cust-repayment-cplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-repayment-cplan',
      componentType: 'cust-repayment-cplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款计划 '
      }
    }
  },
  // 个人产品 本金比例分配表
  'cust-principal-ratio': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-principal-ratio',
      componentType: 'cust-principal-ratio',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '本金比例分配 '
      }
    }
  },
  // 出厂日期  月
  'cust-date-picker-month': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-date-picker-month',
      componentType: 'cust-date-picker-month',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true,
        title: '出厂日期'
      }
    }
  },
  // 申请放款汇总表
  'cust-paymoney-total': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-paymoney-total',
      componentType: 'cust-paymoney-total',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '申请放款汇总表 '
      }
    }
  },
  // 还款信息
  'cust-personal-repay': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-personal-repay',
      componentType: 'cust-personal-repay',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款信息 '
      }
    }
  },
  // 前期款实收表
  'cust-previous-paragraph': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-previous-paragraph',
      componentType: 'cust-previous-paragraph',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '前期款实收表 '
      }
    }
  },
  // 还款记录及计划 通用
  'cust-public-repayment-history': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-repayment-history',
      componentType: 'cust-public-repayment-history',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款记录及计划'
      }
    }
  },
  // 还款记录 通用
  'cust-public-repayment-payplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-repayment-payplan',
      componentType: 'cust-public-repayment-payplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款记录'
      }
    }
  },
  // 通用 内部外部审批意见
  'cust-comment': {
    ctor: 'CustComment',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-comment',
      componentType: 'cust-comment',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款记录'
      }
    }
  },
  // 个人还款 本次还款入账明细  通用
  'cust-public-repayment-detail': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-repayment-detail',
      componentType: 'cust-public-repayment-detail',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '本次还款入账明细'
      }
    }
  },
  //  个人还款 到账以及还款计划表 通用
  'cust-public-repayment-cplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-repayment-cplan',
      componentType: 'cust-public-repayment-cplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '还款计划'
      }
    }
  },
  // 新还款计划 通用
  'cust-public-repayment-newplan': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-repayment-newplan',
      componentType: 'cust-public-repayment-newplan',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '新还款计划'
      }
    }
  },
  // 个人融资文件下载复选框 通用
  'cust-personal-checkbox': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-personal-checkbox',
      componentType: 'cust-personal-checkbox',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '个人融资文件下载复选框'
      }
    }
  },
  // 图片幻灯片预览
  'cust-picture-viewer': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-picture-viewer',
      componentType: 'cust-picture-viewer',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '图片幻灯片预览'
      }
    }
  },
  // 业务请款明细表
  'cust-please-pay-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-please-pay-table',
      componentType: 'cust-please-pay-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none',
        type: 1
      },
      properties: {
        title: '发起节点',
        type: 5
      }
    }
  },
  // 标的物清单
  'cust-target-object-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-target-object-table',
      componentType: 'cust-target-object-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '标的物清单'
      }
    }
  },
  // 带分页的表格
  'cust-public-pagination-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-pagination-table',
      componentType: 'cust-public-pagination-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '自定义分页表格'
      }
    }
  },
  // 上传扣款文件
  'cust-upload-deduction-file': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-upload-deduction-file',
      componentType: 'cust-upload-deduction-file',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '上传扣款文件'
      }
    }
  },
  // 车辆子表
  'cust-vehicle-sublist': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-vehicle-sublist',
      componentType: 'cust-vehicle-sublist',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '车辆子表'
      }
    }
  },
  // 车E估车辆违章查询结果
  'cust-vehicle-violation': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'vehicle-violation',
      componentType: 'cust-vehicle-violation',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '车E估车辆违章查询结果'
      }
    }
  },
  // 未来价格趋势(年度残值)
  'cust-future-price-trend': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'future-price-trend',
      componentType: 'cust-future-price-trend',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '未来价格趋势(年度残值)'
      }
    }
  },
  // 通用日期 年-月 控件
  'cust-public-date-picker-month': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-date-picker-month',
      componentType: 'cust-public-date-picker-month',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true,
        title: '通用日期年-月控件'
      }
    }
  },
  // 企业修改用款计划 流程 搜索结果子表定制
  'cust-enterprise-expense-modify': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-enterprise-expense-modify',
      componentType: 'cust-enterprise-expense-modify',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        state: true,
        title: '企业修改用款计划搜索结果'
      }
    }
  },
  // 删除银行流水-自定义报表查询
  'cust-bank-flow-report': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-bank-flow-report',
      componentType: 'cust-bank-flow-report',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '删除银行流水-自定义报表查询'
      }
    }
  },
  // 合同文本
  'cust-contract-text': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-contract-text',
      componentType: 'cust-contract-text',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '合同文本'
      }
    }
  },
  // 智能柜存资料
  'smart-cabinet-deposit-data': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'smart-cabinet-deposit-data',
      componentType: 'smart-cabinet-deposit-data',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '智能柜存资料'
      }
    }
  },
  // 信息表（客户信息更新流程）
  'information-table-update': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'information-table-update',
      componentType: 'information-table-update',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '信息表'
      }
    }
  },
  // 信息表（客户运营资料补充流程）
  'information-table-replenish': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'information-table-replenish',
      componentType: 'information-table-replenish',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '信息表'
      }
    }
  },
  // 对公-产品管理 本金比例分配表
  'cust-public-principal-ratio': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-principal-ratio',
      componentType: 'cust-public-principal-ratio',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '本金比例分配表'
      }
    }
  },
  // 对公审批组-产品
  'cust-public-product-tables': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-public-product-tables',
      componentType: 'cust-public-product-tables',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '对公审批组产品'
      }
    }
  },
  // 车辆抵押合同
  'cust-download-contract': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'component-id'],
    defaults: {
      name: 'cust-download-contract',
      componentType: 'cust-download-contract',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        title: '车辆抵押合同'
      }
    }
  }
}

function registerSdkComponents () {
  // 合并 sdk 中注册的组件
  if (sdk.componentsDefaults) {
    _.defaults(componentProperties, sdk.componentsDefaults.componentProperties)
    _.defaults(componentProperties, sdk.componentsDefaults.properties)
  }
}

function getProperties (componentType) {
  let component = componentProperties[componentType]
  if (!component) {
    console.error(`请在配置文件 componentDefault.js 中注册 ${componentType} 控件`)
  }
  component.props.forEach(m => {
    if (properties[m]) {
      _.defaults(component.defaults.properties, properties[m])
    }
  })
  return _.cloneDeep(component)
}
export { getProperties, registerSdkComponents }



// WEBPACK FOOTER //
// ./src/store/form/componentDefaults.js